import React, {ChangeEvent, useEffect, useMemo, useState} from 'react';

import {useUnit} from 'effector-react';
import debounce from 'lodash/debounce';
import {useTranslation} from 'react-i18next';

import {taxpayersModel} from '@entities/taxpayers/model';
import {Icon} from '@shared/ui/Icon';
import {Input} from '@shared/ui/Input';

import {ControlRoot, SearchBox} from '../../styled';

export const Control = () => {
    const taxpayers = useUnit(taxpayersModel);
    const {t} = useTranslation();
    const [value, setValue] = useState(taxpayers.state.search);

    useEffect(() => {
        setValue(taxpayers.state.search);
    }, [taxpayers.state.search]);

    const debouncedSearchChanged = useMemo(
        () =>
            debounce((nextValue: string, prevValue: string) => {
                if (nextValue !== prevValue) taxpayers.searchChanged(nextValue);
            }, 1000),
        [],
    );

    useEffect(() => {
        debouncedSearchChanged(value, taxpayers.state.search);
        return debouncedSearchChanged.cancel;
    }, [value, taxpayers.state.search]);

    return (
        <ControlRoot>
            <SearchBox>
                <Input
                    value={value}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
                    placeholder={t('page_taxpayers.search')}
                    adornment={
                        <Icon width={10} height={10} name="cross" onClick={() => setValue('')} />
                    }
                />
            </SearchBox>
        </ControlRoot>
    );
};
